import { Grid } from '@mui/material';
import { memo, useEffect } from 'react';

import useTopPanel from 'hooks/useTopPanel';
import WarehouseFilter from 'components/ui/filters/items/WarehouseFilter';

import ProductStatistics from './items/ProductStatistics';

const StatisticsObject = () => {
  const { setComponent } = useTopPanel();

  useEffect(() => {
    setComponent(
      <div className='component-title flex gap-8 items-center'>
        Ombordagi mahsulotlar statistikasi
        <div className='min-w-[250px]'>
          <WarehouseFilter autoSelect />
        </div>
      </div>
    );
  }, []);

  return (
    <div className='component-wrapper boss-residential-complex-wrapper'>
      <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <Grid item={true} lg={12} md={12} sm={12} xs={12}>
          <ProductStatistics />
        </Grid>
      </Grid>
    </div>
  );
};
export default memo(StatisticsObject);
